import React from 'react';
import { Spin } from 'antd';
import useFlatsGridState from '../../../../../../hooks/useFlatsGridState';
import { useGridUploading } from '../../providers/modals';
import { HourGlassSpinIndicator } from '../../../../../../../../components/SpinIndicators/HourGlassSpinIndicator';

const Loader = ({ children }) => {
  const { flatsGridState } = useFlatsGridState();
  const isFetching = Boolean(flatsGridState?.isFetching);
  const isGridUploading = useGridUploading();

  return (
    <Spin
      spinning={isFetching || isGridUploading}
      indicator={isGridUploading ? <HourGlassSpinIndicator /> : undefined}
      tip={
        isGridUploading ? 'Подождите, идёт обработка файла шахматки' : undefined
      }
    >
      {children}
    </Spin>
  );
};

export default Loader;
